import * as Sentry from '@sentry/browser';
import { Mixpanel } from '/@/core/mixpanel';

export const startUserTracking = (user, country, language) => {
    setInteractiveEvents(true);

    try {
        Mixpanel.identify(user.username);
        Mixpanel.people.set_once({
            email: user.email,
            Email: user.email,
        });
        Mixpanel.people.set({
            first_name: user.first_name,
            last_name: user.last_name,
            validated_phone: user.validated_phone,
            verified_email: user.verified_email,
            type: user.type,
            subtype: user.subtype,
            internal_profile: user.internalProfileEnabled,
            validated_type: user.validated_type,
        });

        Mixpanel.register({
            country: country,
            language: language,
            app: user.app,
        });
        Mixpanel.set_group('type', user.type);
        Mixpanel.set_group('subtype', user.subtype);
        Mixpanel.set_group('internal_profile', user.internalProfileEnabled);
        Mixpanel.set_group('validated_type', user.validated_type);
    } catch (error) {
        console.log(error);
    }

    dataLayer.push({
        event: 'startTracking',
        user_id: user.username,
        user_type: user.type,
        user_sub_type: user.subtype,
        user_internal_profile: user.internalProfileEnabled,
        user_country: country,
        user_language: language,
    });
    gtag('set', { send_page_view: false, user_id: user.username, dimension1: user.username });

    Sentry.getCurrentScope().setUser({
        id: user.username,
        email: user.email,
    });
};

export const stopUserTracking = () => {
    setInteractiveEvents(true);

    dataLayer.push({
        event: 'stopTracking',
        user_id: undefined,
    });
    // gtag('set', { send_page_view: false, user_id: null, dimension1: null });

    Sentry.getCurrentScope().setUser(null);
};

export const setInteractiveEvents = (value) => {
    window.interactiveEvents = value;
};

export const pushToGTMGA = (event) => {
    if (event) {
        dataLayer.push({
            event: event.action,
            event_label: event.label,
            value: event.value,
            page_path: location.pathname + location.search,
            page_location: location.href,
        });
        gtag('event', event.action, {
            event_category: event.category,
            event_label: event.label,
            value: event.value,
            page_path: location.pathname + location.search,
            page_location: location.href,
            non_interaction: !window.interactiveEvents,
        });
    }
};
